import TextWithIcon from 'components/TextWithIcon';
import React from 'react';
import AccordionBodyItem, { AccordionBodyItemProps } from './index';

type Props = Omit<AccordionBodyItemProps, 'children'> & {
  icon: 'mail' | 'phone';
  title: string;
  textClassName?: string;
};

class AccordionTextWithIconItem extends React.Component<Props> {
  render = () => {
    const { title, icon, textClassName, ...other } = this.props;

    return (
      <AccordionBodyItem {...other}>
        <TextWithIcon className={textClassName} icon={icon}>{title}</TextWithIcon>
      </AccordionBodyItem>
    );
  };
}

export default AccordionTextWithIconItem;
